import React from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Login from './pages/Login'
import AppLayout from './components/AppLayout'
import ProtectedRoute from './components/ProtectedRoute'
import CaseForm from './pages/petitioner/CaseForm'
import Guidance from './pages/petitioner/Guidance'
import Receptions from './pages/staff/Receptions'
import Rules from './pages/admin/Rules'

const Home: React.FC = () => {
  const { user, hasRole } = useAuth()
  const location = useLocation()

  if (location.pathname !== '/') {
    return null
  }

  return (
    <AppLayout>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <h1>欢迎使用智能接访引导系统</h1>
        <p>您好，{user?.real_name || user?.username}！</p>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 20, marginTop: 30 }}>
          <div style={{ padding: 20, border: '1px solid #d9d9d9', borderRadius: 8, cursor: 'pointer' }} onClick={() => window.location.href = '/case/new'}>
            <h3>案件录入</h3>
            <p>填写案件基本信息，获取救济途径引导</p>
          </div>
          
          {hasRole('staff') && (
            <div style={{ padding: 20, border: '1px solid #d9d9d9', borderRadius: 8, cursor: 'pointer' }} onClick={() => window.location.href = '/staff/receptions'}>
              <h3>接访管理</h3>
              <p>查看接访记录，导出统计数据</p>
            </div>
          )}
          
          {hasRole('admin') && (
            <>
              <div style={{ padding: 20, border: '1px solid #d9d9d9', borderRadius: 8, cursor: 'pointer' }} onClick={() => window.location.href = '/admin/rules'}>
                <h3>规则管理</h3>
                <p>管理救济途径匹配规则</p>
              </div>
              <div style={{ padding: 20, border: '1px solid #d9d9d9', borderRadius: 8, cursor: 'pointer' }} onClick={() => window.location.href = '/admin/users'}>
                <h3>用户管理</h3>
                <p>管理系统用户和权限</p>
              </div>
            </>
          )}
        </div>
      </div>
    </AppLayout>
  )
}

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      <Route path="/" element={
        <ProtectedRoute>
          <Home />
        </ProtectedRoute>
      } />
      
      <Route path="/case/new" element={
        <ProtectedRoute>
          <AppLayout>
            <CaseForm />
          </AppLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/guidance/:caseId" element={
        <ProtectedRoute>
          <AppLayout>
            <Guidance />
          </AppLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/staff/receptions" element={
        <ProtectedRoute requiredRole="staff">
          <AppLayout>
            <Receptions />
          </AppLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/admin/rules" element={
        <ProtectedRoute requiredRole="admin">
          <AppLayout>
            <Rules />
          </AppLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/unauthorized" element={
        <AppLayout>
          <div style={{ textAlign: 'center', padding: '100px 0' }}>
            <h1>403</h1>
            <p>无权访问</p>
          </div>
        </AppLayout>
      } />
      
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

const App: React.FC = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  )
}

export default App
